var path = '/authoring-homepage-ui/publishingAtAGlance/publishingAtAGlanceOpenCalendar/publishingAtAGlanceOpenCalendar.html';
var html = "<div class=calendar-icon> <svg width=16 height=16 alt=\"{{'Open calendar' | translate}}\" role=img aria-label=\"{{'Open calendar' | translate}}\"> <use xlink:href={{::$ctrl.img}} /> </svg> <span role=link ng-click=$ctrl.navigateToPublishCalendar($event)> <a href=# translate=\"Open calendar\"></a> </span> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/publishingAtAGlance/publishingAtAGlanceOpenCalendar/publishingAtAGlanceOpenCalendar.html
// module id = 108
// module chunks = 0